import { useQueryWithAccessToken } from '../../data-layer/useReactQueryWithAccessToken';
import endpoints from '../../data-layer/endpoints';

export const useGetMediaSearch = (query: string, integration: Integrations) => {
  const queryResult = useQueryWithAccessToken<giphyPexelsType[]>([`${endpoints.GetMediaSearch.endpoint}${integration}.json`, { search: query }], {
    enabled: !!query,
    staleTime: Infinity,
    retry: false,
  });

  const data: MediaSearchItem[] | undefined = queryResult.data?.map((media) => ({
    id: media.id,
    title: media.title,
    thumbUrl: media.url,
    downloadUrl: media.urlToAttach,
    type: 'image',
    isGif: integration === 'Giphy',
  }));

  return {
    data,
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,
  };
};
